import React, {  useState } from "react";
import UserHOC from "../../../components/shared/HOC/UserHOC";
import CustomInput from "../../../components/global/CustomInput/CustomInput";
import LottieIcon from "../../../components/shared/lottieIcon/LottieIcon";
import searchIconsvg from "../../../assets/icons/Search-Icon.svg";
import { useMyGroup } from "../../../hooks/UserHooks/MyGroupsHooks/useMyGroupData";
import CommonTable from "../../../components/shared/table/Table";
import { useNavigate } from "react-router-dom";
import { getGroupColumn } from "../../../assets/constants/user/my-group";

const MyGroups = () => {
  const [isInputHovered, setIsInputHovered] = useState(false); 
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  const columns = getGroupColumn(navigate);

  const { groupData, loading, paginationConfig, handlePageChange } = useMyGroup(search);

  return (
    <div className="rounded-[10px] border p-4 border-[#e8e8e8] bg-white shadow-[0_0_6px_#0000000D] overflow-visible">
      <div className="flex justify-between mb-4">
        <p className="font-medium text-[28px] text-[#E74860]">
          My Groups
        </p>

        <CustomInput
          icon={
            isInputHovered ? (
              <LottieIcon name="searchIcon" size={24} shouldPlay={true} />
            ) : (
              <img
                src={searchIconsvg}
                alt="search"
                style={{ width: 24, height: 24 }}
              />
            )
          }
          onMouseEnter={() => setIsInputHovered(true)}
          onMouseLeave={() => setIsInputHovered(false)}
          placeholder="Search"
          className="w-[300px]"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <CommonTable
        data={groupData}
        columns={columns}
        loading={loading}
        showLoader={loading}
        onChange={handlePageChange}
        className="hide-scrollbar"
        scroll={{ y: "65vh" }}
        serverSide={true}
        pagination={paginationConfig}
      />
    </div>
  );
};

export default UserHOC(MyGroups);